import styled from 'styled-components';

const Wrapper = styled.div`
	position: relative;
`;

const Content = styled.div<{ width: number }>`
	margin-left: ${props =>
		props.width > 1900
			? '320px'
			: props.width <= 1600 && props.width >= 1400
			? '270px'
			: props.width <= 1400 && props.width >= 1200
			? '250px'
			: props.width <= 1200 && props.width >= 1050
			? '220px'
			: '330px'};

	@media (max-width: 1024px) {
		margin-left: 163px;
	}
`;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	Wrapper,
	Content,
};
